import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const UserAPI = {
  getUser: async (token, id) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/user`,
      headers: { Authorization: token },
      params: { id },
    });
  },
  getUserList: async (token, queryParams = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/user/list`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },

  /**
   * Obtiene listado de usuarios con filtros en una hoja de cálculo.
   * @param {string} token Token de autenticación
   * @param {object} params Parámetros de búsqueda
   * @returns {Promise} Respuesta de la API.
   */
  downloadUsers: async (token, params = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/user/report/download`,
      headers: { Authorization: token },
      params,
      responseType: "blob",
    });
  },
  createUser: async (token, data) => {
    return await axios({
      method: "POST",
      url: `${BACKEND_ORIGIN}/api/user/create`,
      headers: { Authorization: token },
      data,
    });
  },
  updateUser: async (token, data) => {
    return await axios({
      method: "POST",
      url: `${BACKEND_ORIGIN}/api/user/update`,
      headers: { Authorization: token },
      data,
    });
  },
  getUserRoles: async (token) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/user/roles`,
      headers: { Authorization: token },
    });
  },
};

export default UserAPI;
